import { String } from 'typescript-string-operations';
export class Diagonal {
    toString() {
        return String.format('{0},{1}', this.Start, this.End);
    }
    get Start() {
        return this.leftTangent.End.point;
    }
    get End() {
        return this.rightTangent.End.point;
    }
    constructor(leftTangent, rightTangent) {
        this.LeftTangent = leftTangent;
        this.RightTangent = rightTangent;
    }
    get LeftTangent() {
        return this.leftTangent;
    }
    set LeftTangent(value) {
        this.leftTangent = value;
    }
    get RightTangent() {
        return this.rightTangent;
    }
    set RightTangent(value) {
        this.rightTangent = value;
    }
    get RbNode() {
        return this.rbNode;
    }
    set RbNode(value) {
        this.rbNode = value;
    }
}
//# sourceMappingURL=Diagonal.js.map